import { useEffect, useState, type RefObject } from 'react';
import type AIChatMessage from '../models/AIChatMessage';

export function useChatAutoScroll(
  messagesEndRef: RefObject<HTMLDivElement | null>,
  inputRef: RefObject<HTMLInputElement | null>,
  messages: AIChatMessage[],
  isProcessing: boolean,
  isUploadingFile: boolean,
) {
  const [hasInitiallyRendered, setHasInitiallyRendered] = useState(false);

  useEffect(() => {
    const lastEl = messagesEndRef.current;
    if (!lastEl) return;
    if (!hasInitiallyRendered) {
      setHasInitiallyRendered(true);
      return;
    }
    if (messages.length > 0) {
      lastEl.scrollIntoView({ behavior: 'smooth', block: 'end' });
      inputRef.current?.focus();
    }
  }, [messagesEndRef, inputRef, messages, isProcessing, isUploadingFile, hasInitiallyRendered]);
}
